import { ENTRI_SETUP_TYPE } from "@/helpers/entriConfig";

const getDefaultState = () => ({
  isFetching: false,
  setupResponse: null,
});

export default {
  namespaced: true,
  state: () => getDefaultState(),
  actions: {
    setupResponse({ commit }, payload) {
      commit("setupResponse", payload);
    },
    isFetching({ commit }, payload) {
      commit("isFetching", payload);
    },
    resetState({ commit }) {
      commit("resetState");
    },
  },
  mutations: {
    setupResponse(state, payload) {
      state.setupResponse = payload;
    },
    isFetching(state, payload) {
      state.isFetching = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
  getters: {
    setupResponse: state => state.setupResponse,
    isFetching: state => state.isFetching,
    setupPossible: (state, getters) =>
      getters?.setupResponse?.setupType === ENTRI_SETUP_TYPE.AUTOMATIC,
    dnsProvider: (state, getters) => getters?.setupResponse?.provider || "",
  },
};
